/*
 * Copyright (c) 2026-present Amida Technology Solutions, Inc.
 * All rights reserved.
 *
 * Licensed under the Amida proprietary license.
 * See LICENSE file in the project root for license information.
 */

import { useEffect } from 'react';

import { useToast } from '@/components/ui/Toast';

/**
 * Where a toast appears. One of these, mounted once, at the app root.
 *
 * Visibility is derived from whether there is a message rather than held in a
 * second piece of state — one source for "is it showing" cannot disagree with
 * itself.
 */
export function Toaster() {
  const message = useToast((s) => s.message);
  const seq = useToast((s) => s.seq);
  const clear = useToast((s) => s.clear);

  useEffect(() => {
    if (!message) return undefined;
    const drop = window.setTimeout(clear, 2800);
    return () => {
      window.clearTimeout(drop);
    };
  }, [message, seq, clear]);

  return (
    <div className={`toast${message ? ' on' : ''}`} role="status" aria-live="polite">
      {message}
    </div>
  );
}
